/* eslint-disable no-unused-vars */

import Button from "components/lib/Shared/Button";
import Checkbox from "components/lib/Shared/Checkbox";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import { useState } from "react";

const ChangeType = ({
  handleGoForward,
  handleGoBack,
  selectedChangeTypes,
  setSelectedChangeTypes,
}) => {
  const selections = [
    {
      id: "annualReturns",
      name: "Annual Return",
    },
    {
      id: "financialStatements",
      name: "Financial Statements",
    },
    {
      id: "annualGeneralMeeting",
      name: "General Meeting",
      disabled: true,
    },
  ];

  const [error, setError] = useState("");

  const handleChangeTypeToggle = (id) => {
    setSelectedChangeTypes((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
  };

  //Handle forward
  const handleForward = () => {
    if (selectedChangeTypes.length > 0) {
      handleGoForward();
    } else {
      setError("Please select at least one option");
    }
  };

  return (
    <div className="mt-4">
      <h2 className="text-sm">
        Select below whether you are filing either or both of the Annual Return
        and the Financial Statement. At least one selection is required.
      </h2>

      <div className="bg-white mt-4 flex p-6 space-x-3">
        {selections.map((item) => (
          <Checkbox
            key={item.id}
            name={item.id}
            label={item.name}
            disabled={item.disabled}
            checked={selectedChangeTypes.includes(item.id)}
            onChange={() => handleChangeTypeToggle(item.id)}
          />
        ))}
      </div>

      {/* Small validation message */}
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}

      <div className="mt-6 flex justify-between gap-4">
        <button
          type="button"
          onClick={() => handleGoBack()}
          className="flex items-start float-right p-2 font-semibold rounded text-primary hover:bg-gray-700 hover:text-white"
        >
          <span className="flex items-center mr-4 h-7">
            <ChevronLeftIcon
              className="flex-shrink-0 w-5 h-5"
              aria-hidden="true"
            />
          </span>
          <p className="font-semibold">Go back</p>
        </button>

        <Button
          type="button"
          onClick={handleForward}
          className="flex px-2 py-2 text-white button button-hover button-disabled button-outline button-focus bg-sflPrimary"
        >
          Save and Proceed
        </Button>
      </div>
    </div>
  );
};

export default ChangeType;
